const IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.avif',
  '.svg',
];

const isString = (value) =>
  typeof value === 'string' && value.trim().length > 0;

const looksLikeImageUrl = (value, keyHint = '') => {
  if (!isString(value)) return false;

  const normalizedValue = value.trim();
  const normalizedKey = String(keyHint || '').toLowerCase();

  if (/^data:image\//i.test(normalizedValue)) return true;
  if (!/^https?:\/\//i.test(normalizedValue)) return false;

  const lowerValue = normalizedValue.toLowerCase();

  if (IMAGE_EXTENSIONS.some((extension) => lowerValue.includes(extension))) {
    return true;
  }

  return ['image', 'img', 'src', 'icon', 'logo', 'avatar', 'photo'].includes(
    normalizedKey
  );
};

export const collectImageSources = (value, seen = new Set(), keyHint = '') => {
  if (!value) return [];

  if (Array.isArray(value)) {
    value.forEach((item) => collectImageSources(item, seen));
    return Array.from(seen);
  }

  if (isString(value)) {
    if (looksLikeImageUrl(value, keyHint)) {
      seen.add(value.trim());
    }
    return Array.from(seen);
  }

  if (typeof value === 'object') {
    Object.entries(value).forEach(([key, child]) => {
      if (isString(child)) {
        if (looksLikeImageUrl(child, key)) {
          seen.add(child.trim());
        }
        return;
      }

      collectImageSources(child, seen, key);
    });
  }

  return Array.from(seen);
};

export const preloadImage = (src) =>
  new Promise((resolve) => {
    if (typeof window === 'undefined' || !src) {
      resolve(false);
      return;
    }

    const image = new Image();

    image.onload = () => resolve(true);
    image.onerror = () => resolve(false);
    image.src = src;

    if (image.complete) {
      resolve(true);
    }
  });
